@if ({ entities: entities$ | async, academicPeriod: academicPeriod$ | async }; as params) {
  <div class="grid pt-6">
    <form [formGroup]="form" (submit)="onAppend(form)">
      @if (!(instance.title | isEmpty)) {
        <p class="mb-6 text-md font-semibold">
          {{ instance.title | translate }}: <span class="font-medium">{{ instance.titleElement | translate }}</span>
        </p>
      }
      @if (showField(params.entities)) {
        <app-form-field>
          <label app-label translate>geral.unidade-escolar</label>
          <ng-select
            app-select
            [clearable]="false"
            [searchable]="false"
            [placeholder]="'geral.unidade-escolar' | translate"
            formControlName="entityId"
            (change)="onChangeEntity($event, params.entities)"
          >
            @for (item of params.entities; track item) {
              <ng-option [value]="item.id">{{ item.name }}</ng-option>
            }
          </ng-select>
        </app-form-field>
      }

      <app-form-field>
        <label app-label translate>geral.turma</label>
        <app-select-group
          app-select
          [entityId]="form.value.entityId"
          [strictUser]="true"
          [searchable]="true"
          formControlName="groupId"
          (changeGroup)="onChangeGroup($event)"
        ></app-select-group>
      </app-form-field>

      <app-form-field>
        <label app-label translate>eclass.disciplina</label>
        <app-select-subject
          app-select
          [filter]="subjectFilter$ | async"
          [searchable]="true"
          [strictUser]="true"
          formControlName="subjectId"
          (changeSubject)="onChangeSubject($event)"
        ></app-select-subject>
      </app-form-field>

      <app-form-field>
        <label app-label translate>geral.data</label>
        <app-input-datepicker
          [weekend]="false"
          [clearable]="false"
          [minDate]="params.academicPeriod.start"
          [maxDate]="params.academicPeriod.end"
          formControlName="date"
        ></app-input-datepicker>
      </app-form-field>

      @if (multiple) {
        <div class="relative flex w-full justify-center">
          <hr class="absolute top-1/2 block w-full border-dashed border-gray-300" />
          <button
            type="submit"
            [disabled]="submitted$ | async"
            app-flat-button
            class="gap-2 rounded-2xl! bg-theme-400 px-5! text-white"
          >
            @if (submitted$ | async) {
              <app-skeleton class="mr-2 h-3! w-3!" baseStyle="bg-theme-400" [showLabel]="false"></app-skeleton>
            } @else {
              <svg-icon class="flex h-3 w-3 text-white" src="assets/icons/icon-plus.svg"></svg-icon>
            }

            <span translate>eclass.turma-disciplina</span>
          </button>
        </div>
      }
    </form>
  </div>
  @if (multiple) {
    <div class="py-6">
      @if (!(targets | isEmpty)) {
        <span class="text-md font-semibold text-theme-500">
          {{ instance.targetsLabel | translate }}
        </span>
        <div class="flex w-full flex-col gap-3 rounded-xl border border-theme-500 bg-white p-2">
          @for (target of targets; track target; let index = $index) {
            <div class="grid grid-cols-12 w-full rounded-md bg-theme-100 p-3">
              <div class="col-span-11">
                <div class="text-md truncate text-gray-70">
                  {{ target.subject.description }}
                </div>
                <div class="flex items-baseline gap-2 truncate text-sm text-gray-600">
                  <span class="capitalize">{{ target.date | dateTranslate: 'dd MMM' }}</span>
                  <svg-icon class="flex h-2 w-2 text-gray-700" src="assets/icons/icon-ellipse.svg"></svg-icon>
                  {{ target.grade.description }}
                  <svg-icon class="flex h-2 w-2 text-gray-700" src="assets/icons/icon-ellipse.svg"></svg-icon>
                  {{ target.group.description }}
                </div>
                @if (showField(params.entities)) {
                  <div class="truncate text-sm text-theme-700">
                    {{ target.entity.description }}
                  </div>
                }
              </div>
              <div class="col-span-1 flex justify-end items-center border-amber-500">
                <svg-icon
                  (click)="onRemove(target, index)"
                  class="w-10 h-10 text-red-400"
                  src="assets/icons/icon-close.svg"
                ></svg-icon>
              </div>
            </div>
          }
        </div>
      } @else {
        <app-jumbotron
          class="mt-14"
          [ngClass]="{ 'border border-red-500 bg-red-100 text-red-500 ': statusError }"
          translate
        >
          eclass.selecione-disciplina-turma
        </app-jumbotron>
      }
    </div>
  }
}
